import * as React from "react";
import "./inlineList.style.css";

interface IProps {
  className?: string;
  children: any;
  noMargin?: boolean;
}

const InlineList = (props: IProps) => {
  const { className = "", children, noMargin = false } = props;
  return (
    <ul className={`inlineList ${noMargin ? "-no-margin" : ""} ${className}`}>
      {children}
    </ul>
  );
};

export default InlineList;
